/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { SidebarGlobal } from "../Sidebar";
import Icon from "../Icon";
import Globals from "../../shared/Globals";

class ReportViewer extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: null
        };
        this.renderValue = this.renderValue.bind(this);
        this.export = this.export.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<>
            <button type="submit" className="btn btn-primary" onClick={this.export}><Icon icon="faFileExcel" /> <span className="d-none d-md-inline">Export</span></button>
        </>);
        qreq.get('/api/report/get/' + this.props.params.ident, j => {
            if(j.item)
                this.setState({ item: j.item });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    export() {
        window.open(Globals.serverUrl + '/api/report/export/' + this.props.params.ident, '_blank');
    }

    renderValue(col, row, j) {
        var item = row.values[j];
        var val = item.value;
        if(col.type === 'int')
            val = parseInt(val);
        if(col.type === 'datetime') {
            var dt = Date.parse(val);
            if(dt)
                val = Globals.toMDYHMLocalDateString(new Date(dt));
        }
        if(item.link)
            return <Link to={item.link}>{val}</Link>;
        return val;
    }

    render() {
        return <div className="container-fluid">
            <h1>{this.state.item?.name}</h1>
            {this.state.item && <table className="table table-bordered">
                <thead>
                    <tr>
                        {this.state.item.columns.map((col, i) => <th key={i}>{col.name}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {this.state.item.items.map((row, i) => <tr key={i}>
                        {this.state.item.columns.map((col, j) => <td key={j}>
                            {this.renderValue(col, row, j)}
                        </td>)}
                    </tr>)}
                </tbody>
            </table>}
        </div>;
    }
}

export default withParamsAndNavigate(ReportViewer);